import { EFrequency } from "src/app/domain/enum/frequency"
import { EWorkType } from "src/app/domain/enum/work-type"
import { PDREContact } from "./PDRE-contact.dto";
import { Client } from "src/app/domain/client";

export class PDREDonneesAdministrativesDTO {
    // NomClient: string;
    Client: Client;
    Siret: string;
    ReferenceInterne: string;
    NomChantier: string;
    AdresseChantier: string;
    CodePostal: string;
    Ville: string;
    TypeOperation: EWorkType;
    DebutChantier: Date;
    DureeChantier: number;
    UniteDuree: EFrequency;
    NbOperateurs: number;
    ContactList: PDREContact[];
    ExtractionSuccessful: boolean;

    static mapFromJSON(json) {
        const cm = new PDREDonneesAdministrativesDTO;

        // cm.NomClient = json['nomClient'];
        if (json['client'])
            cm.Client = Client.mapFromJSON(json['client']);
        cm.Siret = json['siret'];
        cm.ReferenceInterne = json['referenceInterne'];
        cm.NomChantier = json['nomChantier'];
        cm.AdresseChantier = json['adresseChantier'];
        cm.CodePostal = json['codePostal'];
        cm.Ville = json['ville'];
        cm.TypeOperation = json['typeOperation'];
        cm.DebutChantier = json['debutChantier'];
        cm.DureeChantier = json['dureeChantier'];
        cm.UniteDuree = json['uniteDuree'];
        cm.NbOperateurs = json['nbOperateurs'];
        cm.ExtractionSuccessful = json['extractionSuccessful'];

        cm.ContactList = json['contactList'] ? json['contactList'].map(item => PDREContact.mapFromJSON(item)) : [];
        return cm;
    }
}